import React, { lazy, Suspense, useEffect, useState } from "react";
import Cookies from "js-cookie";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
// import TradeBehaviorChart from "../component/TradeBehaviorChart";
// import DepositWithdrawalChart from "../component/DepositWithdrawalChart";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL, REFERRAL_BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import Loader from "../component/Loader";
import { WebSocketDemo } from "../component/WebSocketDemo";
import { getAuthToken } from "../token";
import MessageToster from "../component/MessageToster";
import { closeModal } from "../utils/modal";
import CommonTable from "../component/CommonTable";
import copy from "copy-to-clipboard";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";

const TradeBehaviorChart = lazy(() => import("../component/TradeBehaviorChart"));
const DepositWithdrawalChart = lazy(() => import("../component/DepositWithdrawalChart"));

export default function Home() {
  const navigate = useNavigate();
  const { userData: contextUserData } = useUser();
  const cookieUserData = JSON.parse(Cookies.get("userdata") || "{}");
  const userData = contextUserData || cookieUserData;
  const rawIbStatus = String(userData?.ibStatus || "").toLowerCase().trim();
  const isIbActive = Number(userData?.isIb) === 1 || ["active", "approve", "approved"].includes(rawIbStatus);
  const isIbPending = rawIbStatus === "pending";
  const isIbRejected = ["reject", "rejected"].includes(rawIbStatus);

  const renderKycBadge = (status) => {
    console.log("statts", status)
    const s = String(status || "").toLowerCase().trim();
    if (s === "approve" || s === "verified") {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 font-size-12">
          <i className="bx bx-check-shield me-1" /> Approved
        </span>
      );
    }
    if (s === "rejected") {
      return (
        <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 font-size-12">
          <i className="bx bx-x-circle me-1" /> Rejected
        </span>
      );
    }
    return (
      <span className="badge bg-warning-subtle text-warning border border-warning-subtle px-2 py-1 font-size-12">
        <i className="bx bx-time-five me-1" /> {status || "Pending"}
      </span>
    );
  };

  const renderBankDetailsBadge = (isAdded) => {
    const added = isAdded === true || isAdded === "true" || isAdded === 1;
    if (added) {
      return (
        <span className="badge bg-success-subtle text-success border border-success-subtle px-2 py-1 font-size-12">
          <i className="bx bx-check-circle me-1" /> Added
        </span>
      );
    }
    return (
      <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-2 py-1 font-size-12">
        <i className="bx bx-x-circle me-1" /> Not Added
      </span>
    );
  };
  const handleError = useHandleError();
  const [loading, setLoading] = useState(false);
  const [liveAccountCount, setLiveAccountCount] = useState(0);
  const [demoAccountCount, setDemoAccountCount] = useState(0);
  const [mid] = useState(() => sessionStorage.getItem("mid"));
  const [token] = useState(() => getAuthToken());
  const [ibLoading, setIbLoading] = useState(false);
  const [beforeReg, setBeforeReg] = useState(false);
  const [ibTimer, setIbTimer] = useState(0);
  const [ibData, setIbData] = useState({
    email: userData?.email || "",
    fname: "",
    lname: "",
    yearofexp: "",
    companyname: "",
    existclients: "",
    avgvolume: "",
    verifycode: "",
  });
  const [dashboardData, setDashboardData] = useState(null);
  const [ibErrors, setIbErrors] = useState({});
  const totalBal = Number(dashboardData?.in_wallet) - Number(dashboardData?.out_wallet);

  const referralCode = userData?.loginid || userData?.ref_code || userData?.referral_code || "";
  const referralLink = referralCode ? `${REFERRAL_BASE_URL}${referralCode}` : REFERRAL_BASE_URL;

  const copyReferralLink = () => {
    if (!referralLink) return;
    try {
      const success = copy(referralLink);
      if (success) {
        MessageToster("success", `Referral link copied!`);
      } else {
        MessageToster("error", "Failed to copy link");
      }
    } catch {
      MessageToster("error", "Failed to copy link");
    }
  };

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${BASE_URL}/account/deshbord`, { data: {} }, { headers: getApiHeaders() });
      if (res.data && res.data.code === 200) {
        const item = Array.isArray(res?.data?.data) ? res?.data?.data[0] : res?.data?.data;
        setDashboardData(item || {});
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {

      try {
        if (!mid || !token) return;

        setLoading(true);

        // const inputBody = {};
        // const inputBody = { mid: Number(mid), mode: "" };

        const [liveRes, demoRes] = await Promise.all([
          axios.get(`${BASE_URL}/MT5M/real_accounts_number_list`, { headers: getApiHeaders() }),
          axios.get(`${BASE_URL}/MT5M/demo_account_number_list`, { headers: getApiHeaders() })
        ]);

        if (liveRes.data.code === 200) {
          setLiveAccountCount(liveRes.data.data?.length || 0);
        }

        if (demoRes.data.code === 200) {
          setDemoAccountCount(demoRes.data.data?.length || 0);
        }

      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [mid, token]);

  useEffect(() => {
    let interval = null;
    if (ibTimer > 0) {
      interval = setInterval(() => {
        setIbTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [ibTimer]);

  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleIbChange = (e) => {
    const { name, value } = e.target;

    if (name === "avgvolume") {
      if (!/^\d*\.?\d*$/.test(value)) return;
    } else if (["yearofexp", "existclients", "verifycode"].includes(name)) {
      if (!/^\d*$/.test(value)) return;
    }

    setIbData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setIbErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const resetIbForm = () => {
    setIbData({
      email: userData?.email || "",
      fname: "",
      lname: "",
      yearofexp: "",
      companyname: "",
      existclients: "",
      avgvolume: "",
      verifycode: "",
    });
    setIbErrors({});
    setBeforeReg(false);
    setIbTimer(0);
  };

  const validateForm = () => {
    const errors = {};

    // Email validation
    if (!ibData.email || ibData.email.trim() === "") {
      errors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(ibData.email)) {
      errors.email = "Enter valid email";
    }

    // First Name validation
    if (!ibData.fname || ibData.fname.trim() === "") {
      errors.fname = "First name is required";
    } else if (ibData.fname.trim().length < 2) {
      errors.fname = "First name must be at least 2 characters";
    } else if (!/^[a-zA-Z\s.-]+$/.test(ibData.fname)) {
      errors.fname = "First name must contain only letters";
    }

    // Last Name validation
    if (!ibData.lname || ibData.lname.trim() === "") {
      errors.lname = "Last name is required";
    } else if (ibData.lname.trim().length < 2) {
      errors.lname = "Last name must be at least 2 characters";
    } else if (!/^[a-zA-Z\s.-]+$/.test(ibData.lname)) {
      errors.lname = "Last name must contain only letters";
    }

    // Year of Experience validation
    if (!ibData.yearofexp || ibData.yearofexp.toString().trim() === "") {
      errors.yearofexp = "Year of experience is required";
    } else {
      const exp = Number(ibData.yearofexp);
      if (isNaN(exp) || exp < 0 || exp > 80) {
        errors.yearofexp = "Enter a valid year of experience (0-80)";
      }
    }

    // Company Name validation
    if (!ibData.companyname || ibData.companyname.trim() === "") {
      errors.companyname = "Company name is required";
    } else if (ibData.companyname.trim().length < 2) {
      errors.companyname = "Company name must be at least 2 characters";
    }

    // Existing Clients validation
    if (!ibData.existclients || ibData.existclients.toString().trim() === "") {
      errors.existclients = "Existing clients is required";
    } else {
      const clients = Number(ibData.existclients);
      if (isNaN(clients) || clients < 0) {
        errors.existclients = "Existing clients must be a non-negative number";
      }
    }

    // Average Volume validation
    if (!ibData.avgvolume || ibData.avgvolume.toString().trim() === "") {
      errors.avgvolume = "Average volume is required";
    } else {
      const vol = Number(ibData.avgvolume);
      if (isNaN(vol) || vol < 0) {
        errors.avgvolume = "Average volume must be a non-negative number";
      }
    }

    // OTP Verification validation
    if (beforeReg) {
      if (!ibData.verifycode || ibData.verifycode.toString().trim() === "") {
        errors.verifycode = "OTP is required";
      } else if (ibData.verifycode.toString().length !== 6) {
        errors.verifycode = "OTP must be 6 digits";
      } else if (!/^\d+$/.test(ibData.verifycode)) {
        errors.verifycode = "OTP must contain only numbers";
      }
    }

    setIbErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const sendIbOtp = async () => {
    if (!validateForm()) return;
    try {
      setIbLoading(true);
      const body = {
        email: ibData.email,
        otype: "IBREGISTER",
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/before_register`,
        body,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        setBeforeReg(true);
        setIbTimer(120);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  const resendIbOtp = async () => {
    if (ibTimer > 0 || ibLoading) return;
    try {
      setIbLoading(true);
      const body = {
        email: ibData.email,
        otype: "IBREGISTER",
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/before_register`,
        body,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message || "OTP resent successfully");
        setIbTimer(120);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  const submitIbForm = async () => {
    if (!validateForm()) return;
    try {
      setIbLoading(true);
      const bodyData = {
        email: ibData.email,
        verifycode: Number(ibData.verifycode),
        fname: ibData.fname,
        lname: ibData.lname,
        yearofexp: ibData.yearofexp,
        companyname: ibData.companyname,
        existclients: ibData.existclients,
        avgvolume: ibData.avgvolume,
      };
      const res = await axios.post(
        `${BASE_URL}/NEW_IB/register`,
        bodyData,
        {
          headers: getApiHeaders(),
        }
      );
      if (res.data.code === 200) {
        MessageToster("success", res.data.message);
        setIbData({
          email: userData?.email || "",
          fname: "",
          lname: "",
          yearofexp: "",
          companyname: "",
          existclients: "",
          avgvolume: "",
          verifycode: "",
        });
        closeModal();
        setIbErrors({});
        setBeforeReg(false);
        setIbTimer(0);
      } else {
        MessageToster("error", res.data.message);
      }
    } catch (error) {
      handleError(error);
    } finally {
      setIbLoading(false);
    }
  };

  return (
    <>
      <div id="layout-wrapper">
        {loading && <Loader />}
        <Topbar />
        <Sidebar />
        {/* <WebSocketDemo /> */}
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Dashboard</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              {/* Top Row: 5 Main Financial Stats */}
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-5 g-3 mb-4">
                {/* 1. Total Balance */}
                <div className="col">
                  <div className="card card-animate bg-warning-subtle overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold fs-17 text-muted mb-0">Total Balance</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                            <span className="counter-value">
                              {dashboardData?.total_balance !== undefined && dashboardData?.total_balance !== null
                                ? Number(dashboardData.total_balance).toFixed(2)
                                : "0.00"}
                            </span>
                          </h2>
                        </div>
                        <div className="mini-stat-icon">
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title bg-warning rounded-circle fs-2">
                              <i className="bx bx-credit-card font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. Total Equity */}
                <div className="col">
                  <div className="card card-animate bg-primary-subtle overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold fs-17 text-muted mb-0">Total Equity</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                            <span className="counter-value">
                              {dashboardData?.total_equity !== undefined && dashboardData?.total_equity !== null
                                ? Number(dashboardData.total_equity).toFixed(2)
                                : "0.00"}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title bg-primary rounded-circle fs-2">
                              <i className="bx bx-doughnut-chart font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 3. Total Deposit */}
                <div className="col">
                  <div className="card card-animate bg-info-subtle overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold fs-17 text-muted mb-0">Total Deposit</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                            <span className="counter-value">
                              {dashboardData?.total_deposit !== undefined && dashboardData?.total_deposit !== null
                                ? Number(dashboardData.total_deposit).toFixed(2)
                                : "0.00"}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title bg-info rounded-circle fs-2">
                              <i className="bx bx-down-arrow-circle font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 4. Total Withdraw */}
                <div className="col">
                  <div className="card card-animate bg-success-subtle overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold fs-17 text-muted mb-0">Total Withdraw</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                            <span className="counter-value">
                              {dashboardData?.total_withdraw !== undefined && dashboardData?.total_withdraw !== null
                                ? Number(dashboardData.total_withdraw).toFixed(2)
                                : "0.00"}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title bg-success rounded-circle fs-2">
                              <i className="bx bx-up-arrow-circle font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 5. Total Profit/Loss */}
                <div className="col">
                  <div className="card card-animate bg-danger-subtle overflow-hidden h-100 mb-0">
                    <div className="card-body upcoming-box">
                      <div className="d-flex justify-content-between">
                        <div>
                          <p className="fw-bold fs-17 text-muted mb-0">Total Profit/Loss</p>
                          <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                            <span className="counter-value">
                              {dashboardData?.total_profit_loss !== undefined && dashboardData?.total_profit_loss !== null
                                ? Number(dashboardData.total_profit_loss).toFixed(2)
                                : "0.00"}
                            </span>
                          </h2>
                        </div>
                        <div>
                          <div className="avatar-sm upcoming-icon flex-shrink-0">
                            <span className="avatar-title bg-danger rounded-circle fs-2">
                              <i className="bx bx-bar-chart-square font-size-24" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 2: Main Dashboard Content (Left: Wallet & Deposit Chart | Right: Accounts & Become Broker) */}
              <div className="row g-4">
                {/* Left Column: Wallet Summary & Deposit/Withdrawal Chart */}
                <div className="col-xl-4 col-lg-5 col-12">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="text-muted text-center">
                        <div className="bg-primary-subtle p-3 rounded-4">
                          <h4 className="card-title mb-0">Account Overview</h4>
                        </div>
                      </div>
                      <div className="table-responsive mt-md-4 mt-2">
                        <CommonTable
                          hideHeader={true}
                          disablePagination={true}
                          columns={[
                            {
                              accessor: "label",
                              className: "border-end",
                              render: (row) => (
                                <h5 className="font-size-14 mb-1 text-muted fw-semibold">{row.label}</h5>
                              )
                            },
                            {
                              accessor: "value",
                              render: (row) => (
                                <div className="mb-0">{row.value}</div>
                              )
                            }
                          ]}
                          data={[
                            {
                              label: "KYC Status",
                              value: renderKycBadge(userData?.kyc_status)
                            },
                            {
                              label: "Bank Details",
                              value: renderBankDetailsBadge(userData?.isBankDetailsAdded)
                            },
                            {
                              label: "Deposit Limit",
                              value: (
                                <span className="fw-bold text-dark font-size-14">
                                  {userData?.deposit_limit !== undefined && userData?.deposit_limit !== null
                                    ? Number(userData.deposit_limit).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : "0.00"}{" "}
                                  <span className="font-size-11 text-muted fw-normal">USD</span>
                                </span>
                              )
                            }
                          ]}
                          tableClassName="table align-middle mb-0"
                        />
                      </div>
                    </div>
                  </div>

                  <Suspense fallback={<Loader />}>
                    <DepositWithdrawalChart data={dashboardData} />
                  </Suspense>
                </div>

                {/* Right Column: Account Stats & Become Broker */}
                <div className="col-xl-8 col-lg-7 col-12">
                  {/* Account Overview Cards */}
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="card card-animate shadow-none bg-warning-subtle mb-3">
                            <div className="card-body upcoming-box">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <h4 className="mb-2 fw-bold">
                                    {dashboardData?.live_account !== undefined && dashboardData?.live_account !== null
                                      ? dashboardData.live_account
                                      : (liveAccountCount ?? "0")}
                                  </h4>
                                  <p className="text-muted mb-2">Live Account</p>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title bg-warning rounded-circle upcoming-icon text-white font-size-20">
                                    <i className="bx bx-bar-chart-square" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card card-animate shadow-none bg-info-subtle mb-0">
                            <div className="card-body upcoming-box">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <h4 className="mb-2 fw-bold">
                                    {dashboardData?.demo_account !== undefined && dashboardData?.demo_account !== null
                                      ? dashboardData.demo_account
                                      : (demoAccountCount ?? "0")}
                                  </h4>
                                  <p className="text-muted mb-2">Demo Account</p>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title bg-info rounded-circle upcoming-icon text-white font-size-20">
                                    <i className="bx bx-desktop" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          {/* Income Wallet */}
                          <div className="card upcoming-box shadow-none mini-stats-wid bg-primary-subtle mb-3">
                            <div className="card-body">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <h4 className="mb-2 fw-bold">
                                    {userData?.commissionwallet !== undefined && userData?.commissionwallet !== null
                                      ? Number(userData.commissionwallet).toFixed(2)
                                      : "0.00"}{" "}
                                    <span className="font-size-12 text-muted fw-normal">USD</span>
                                  </h4>
                                  <p className="text-muted mb-2">Income Wallet</p>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title bg-primary rounded-circle upcoming-icon text-white font-size-20">
                                    <i className="bx bx-wallet" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Deposit Wallet */}
                          <div className="card upcoming-box shadow-none mini-stats-wid mb-0 bg-success-subtle">
                            <div className="card-body">
                              <div className="d-flex flex-wrap">
                                <div className="me-3">
                                  <h4 className="mb-2 fw-bold">
                                    {userData?.pinwallet !== undefined && userData?.pinwallet !== null
                                      ? Number(userData.pinwallet).toFixed(2)
                                      : "0.00"}{" "}
                                    <span className="font-size-12 text-muted fw-normal">USD</span>
                                  </h4>
                                  <p className="text-muted mb-2">Deposit Wallet</p>
                                </div>
                                <div className="mini-stat-icon avatar-sm ms-auto">
                                  <div className="avatar-title bg-success rounded-circle upcoming-icon text-white font-size-20">
                                    <i className="bx bx-dollar-circle" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Become Broker Card */}
                  <div className="card welcome-card">
                    <div className="card-body position-relative">
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h1>Become Broker</h1>
                          <p>
                            {isIbActive
                              ? "Your IB account is active & verified"
                              : isIbPending
                                ? "Your IB application is under review"
                                : isIbRejected
                                  ? "Application not approved - re-apply now"
                                  : "Apply For The Introducing Broker"}
                          </p>
                          <button
                            type="button"
                            className="btn"
                            onClick={() => {
                              if (isIbActive) {
                                navigate("/ib_dashboard");
                              } else {
                                navigate("/become-ib");
                              }
                            }}
                          >
                            {isIbActive
                              ? "IB Dashboard"
                              : isIbPending
                                ? "Pending Approval"
                                : isIbRejected
                                  ? "Re-Apply IB"
                                  : "Become An IB"}
                          </button>
                        </div>
                        <div className="flex-shrink-0">
                          <img src="assets/images/broker.png" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Invite Friends & Earn Card */}
                  <div
                    className="card mt-3 shadow-sm border-0"
                    style={{
                      borderRadius: "14px",
                      border: "1px solid #e9edf2",
                    }}
                  >
                    <div className="card-body p-3 p-md-4">
                      <div className="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="flex-shrink-0 bg-primary-subtle rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: "48px",
                              height: "48px",
                              minWidth: "48px",
                            }}
                          >
                            <i
                              className="bx bx-share-alt text-primary"
                              style={{ fontSize: "22px" }}
                            />
                          </div>
                          <div>
                            <h5 className="fw-bold mb-1" style={{ fontSize: "16px" }}>
                              Invite Friends
                            </h5>
                            <p className="text-muted mb-0 font-size-13">
                              Share your referral link to build your team.
                            </p>
                          </div>
                        </div>
                        <div className="input-group w-100" style={{ maxWidth: "440px" }}>
                          <input
                            type="text"
                            className="form-control"
                            readOnly
                            value={referralLink}
                            style={{ fontSize: "13px" }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center gap-1 px-3 fw-semibold shadow-sm"
                            onClick={copyReferralLink}
                          >
                            <i className="bx bx-copy font-size-16" /> Copy
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>
          <Footer />
        </div>
      </div>
      {/* IB Account Modal - Commented out, now redirected to dedicated /become-ib page
      <div
        className="modal fade bs-example-modal-center"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">IB Account</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetIbForm}
              />
            </div>
            <div className="modal-body">
              <div className="col-12 mb-3">
                <label className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={ibData.email}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.email && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.email}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="First Name"
                  name="fname"
                  value={ibData.fname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.fname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.fname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Last Name"
                  name="lname"
                  value={ibData.lname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.lname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.lname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Year Of Experience
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="yearofexp"
                  placeholder="Year Of Experience"
                  value={ibData.yearofexp}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.yearofexp && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.yearofexp}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Company Name"
                  name="companyname"
                  value={ibData.companyname}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.companyname && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.companyname}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  No. Of Existing Client
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="existclients"
                  placeholder="No. Of Existing Client"
                  value={ibData.existclients}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.existclients && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.existclients}</span>
                  </div>
                )}
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">
                  Average Volume Per Month
                  <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="number"
                  name="avgvolume"
                  placeholder="Average Volume Per Month"
                  value={ibData.avgvolume}
                  onChange={handleIbChange}
                  disabled={beforeReg}
                />
                {ibErrors.avgvolume && (
                  <div className="text-danger small mt-1 d-flex align-items-center">
                    <i className="bx bx-info-circle me-1 font-size-14"></i>
                    <span>{ibErrors.avgvolume}</span>
                  </div>
                )}
              </div>

              {beforeReg && (
                <div className="col-12 mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <label className="form-label mb-0">
                      Verify OTP <span className="text-danger">*</span>
                    </label>
                    {ibTimer > 0 ? (
                      <span className="text-muted small">
                        Resend in <strong className="text-primary">{formatTimer(ibTimer)}</strong>
                      </span>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-link btn-sm p-0 text-decoration-none fw-semibold"
                        onClick={resendIbOtp}
                        disabled={ibLoading}
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>
                  <input
                    type="text"
                    maxLength={6}
                    className="form-control"
                    placeholder="Enter OTP"
                    name="verifycode"
                    value={ibData.verifycode}
                    onChange={handleIbChange}
                  />
                  {ibErrors.verifycode && (
                    <div className="text-danger small mt-1 d-flex align-items-center">
                      <i className="bx bx-info-circle me-1 font-size-14"></i>
                      <span>{ibErrors.verifycode}</span>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={resetIbForm}
              >
                Reset
              </button>
              {!beforeReg ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendIbOtp}
                  disabled={ibLoading}
                >
                  {ibLoading ? "Sending OTP..." : "Send OTP"}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitIbForm}
                  disabled={ibLoading}
                >
                  {ibLoading ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      */}
    </>
  );
}


//  <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-warning-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-warning">
//                             <i className="bx bx-credit-card font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Balance
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-1"
//                               data-colors='["--bs-warning"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-primary-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-primary">
//                             <i className="bx bx-doughnut-chart font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Equity
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-2"
//                               data-colors='["--bs-primary"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-info-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-info">
//                             <i className="bx bx-trending-up font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">0.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Margin in use{" "}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-3"
//                               data-colors='["--bs-info"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-xl-3 col-lg-6 col-sm-6">
//                   <div className="card mini-stats-wid">
//                     <div className="card-body bg-success-subtle">
//                       <div className="flex-shrink-0 align-self-center pb-3">
//                         <div className="mini-stat-icon avatar-sm rounded-circle bg-primary">
//                           <span className="avatar-title bg-success">
//                             <i className="bx bx-dollar-circle font-size-24" />
//                           </span>
//                         </div>
//                       </div>
//                       <div className="row pt-3">
//                         <div className="col-6">
//                           <div>
//                             <h3 className="h3 fw-bold">100.00</h3>
//                             <p className="text-muted text-truncate mb-0">
//                               Total Free Margin
//                             </p>
//                           </div>
//                         </div>
//                         <div className="col-6">
//                           <div>
//                             <div
//                               id="area-sparkline-chart-3"
//                               data-colors='["--bs-success"]'
//                               className="apex-charts"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>